export enum EnumKnowledgeErrorCode {
  DOCUMENT_NOT_FOUND = 'document_not_found',
  DOCUMENT_UNAVAILABLE = 'document_unavailable',
  KNOWLEDGE_UNAVAILABLE = 'knowledge_unavailable'
}
